var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ic-info-a",
    d: "M13.75,5 C8.2271525,5 3.75,9.4771525 3.75,15 C3.75,20.5228475 8.2271525,25 13.75,25 C19.2728475,25 23.75,20.5228475 23.75,15 C23.75,9.4771525 19.2728475,5 13.75,5 Z M13.75,12.5 C14.4403559,12.5 15,13.0596441 15,13.75 L15,20 C15,20.6903559 14.4403559,21.25 13.75,21.25 C13.0596441,21.25 12.5,20.6903559 12.5,20 L12.5,13.75 C12.5,13.0596441 13.0596441,12.5 13.75,12.5 Z M13.75,11.25 C13.0596441,11.25 12.5,10.6903559 12.5,10 C12.5,9.30964406 13.0596441,8.75 13.75,8.75 C14.4403559,8.75 15,9.30964406 15,10 C15,10.6903559 14.4403559,11.25 13.75,11.25 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#9FABBB",
    xlinkHref: "#ic-info-a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic-info.aded00ef.svg";
export { ForwardRef as ReactComponent };